import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import { GenderList, DateList, MonthList, YearList } from 'assert/OptionList';
import {
  PersonalContainer,
  SubmitContainer,
} from 'pages/addprofile/Profile.style';
import { Input, Button, Select, BrandIconSpinner } from 'components';
import {
  getProfileByuserName,
  updateProfileFun,
  updateProfileList,
} from 'redux/features/ProfileSlice';
import AutoComplete from 'components/AutoComplete';
import { getCountryList } from 'redux/features/DropDownSlice';
// import CheckBox from 'components/CheckBox';
import moment from 'moment';

const PersonalDetails = ({ personalData, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const { countryList } = useSelector((state) => state?.DropdownReducer);

  const [loading, setloading] = useState(true);
  const [PersonalDetails, setPersonalDetails] = useState({
    displayName: '',
    headline: '',
    day: '',
    month: '',
    year: '',
    gender: '',
    country: '',
    city: '',
    isEmailVisible: false,
  });
  const [errMsg, setErrmsg] = useState({
    displayName: '',
    headline: '',
    day: '',
    month: '',
    year: '',
    gender: '',
    country: '',
    city: '',
  });

  useEffect(() => {
    countryList?.length === 0 && dispatch(getCountryList());
  }, []);

  useEffect(() => {
    const userData = personalData?.details;
    if (userData) {
      PersonalDetails.displayName = userData?.displayName || '';
      PersonalDetails.headline = userData?.headline;
      PersonalDetails.gender = userData?.gender || '';
      PersonalDetails.country = userData?.country || '';
      PersonalDetails.city = userData?.city || '';
      PersonalDetails.day = userData?.dob?.split('-')?.[2] || '';
      PersonalDetails.month = userData?.dob?.split('-')?.[1] || '';
      PersonalDetails.year = userData?.dob?.split('-')?.[0] || '';
      PersonalDetails.isEmailVisible = Boolean(userData?.isEmailVisible);
      setPersonalDetails((prevState) => ({
        ...prevState,
      }));
      setloading(false);
    }
  }, [personalData]);

  const handleChange = useCallback(
    (data, name) => {
      setPersonalDetails((prevState) => ({
        ...prevState,
        [name]: data,
      }));
    },
    [PersonalDetails]
  );

  const handleValidation = () => {
    const updatedErrMsg = { ...errMsg };

    Object.keys(updatedErrMsg).forEach((data) => {
      if (data === 'country') {
        const countryTrimmedValue =
          typeof PersonalDetails[data]?.label === 'string'
            ? PersonalDetails.country?.label.trim()
            : typeof PersonalDetails[data] === 'string'
            ? PersonalDetails[data].trim()
            : '';
        updatedErrMsg[data] = !countryTrimmedValue ? 'Field Required' : '';
      } else {
        const trimmedValue =
          typeof PersonalDetails[data] === 'string' ||
          typeof PersonalDetails[data] === 'number'
            ? String(PersonalDetails[data]).trim()
            : '';
        updatedErrMsg[data] = !trimmedValue ? 'Field Required' : '';
      }
    });

    setErrmsg(updatedErrMsg);

    return Object.keys(updatedErrMsg).every(
      (it) => updatedErrMsg[it]?.trim() === ''
    );
  };

  const handleSubmit = () => {
    const { day, month, year } = PersonalDetails;
    if (moment().diff(moment(`${year}-${month}-${day}`), 'years') < 13) {
      Notification('error', 'Sorry, users must be 13 or older.');
      return;
    }
    if (handleValidation()) {
      setloading(true);
      const formData = {
        displayName: PersonalDetails.displayName,
        headline: PersonalDetails.headline,
        dob: `${PersonalDetails?.year}-${PersonalDetails?.month}-${PersonalDetails?.day}`,
        gender: PersonalDetails.gender,
        country: PersonalDetails.country?.label,
        city: PersonalDetails.city,
        isEmailVisible: PersonalDetails.isEmailVisible,
      };
      dispatch(updateProfileList(formData, getProfile?.userId, 'createProfile'))
        .then(() => {
          dispatch(getProfileByuserName());
          dispatch(updateProfileFun(''));
          Notification('success', 'Personal info updated successfully');
          onClose(false, 'personal');
          setloading(false);
        })
        .catch((err) => {
          Notification('warning', err.response?.data?.message);
          setloading(false);
        });
    }
  };

  return (
    <>
      <BrandIconSpinner loading={loading} />
      <PersonalContainer>
        <Input
          label={t('profile.FullName')}
          value={PersonalDetails.displayName}
          onChange={(data) => handleChange(data, 'displayName')}
          errMsg={errMsg.displayName}
          required
        />
        <Input
          label={t('profile.HeadLine')}
          value={PersonalDetails.headline}
          onChange={(data) => handleChange(data, 'headline')}
          errMsg={errMsg.headline}
          required
          multiline
          maxLimit={200}
        />
        <div className="date-container">
          <div className="lebelView">
            <label>
              {t('profile.Dob')} <span className="requiredSymbol">*</span>
            </label>
          </div>
          <div className="date-select-field">
            <Select
              Options={MonthList}
              value={PersonalDetails.month}
              onChange={(data) => handleChange(data.target.value, 'month')}
            />
            <Select
              Options={DateList}
              value={PersonalDetails.day}
              onChange={(data) => handleChange(data.target.value, 'day')}
            />
            <Select
              Options={YearList}
              value={PersonalDetails.year}
              onChange={(data) => handleChange(data.target.value, 'year')}
            />
          </div>
        </div>
        <Select
          Options={GenderList}
          label={t('profile.Gender')}
          value={PersonalDetails.gender}
          onChange={(data) => handleChange(data.target.value, 'gender')}
          errMsg={errMsg.gender}
          required
          // ValuebyId
        />
        <div className="field-wrap">
          <AutoComplete
            Options={countryList}
            label={t('profile.ProfileCountry')}
            value={PersonalDetails.country}
            onChange={(data) => handleChange(data, 'country')}
            errMsg={errMsg.country}
            ListboxProps={{ style: { maxHeight: '30vh' } }}
            freeSolo
            required
          />
          <Input
            label={t('profile.ProfileCity')}
            value={PersonalDetails.city}
            onChange={(data) => handleChange(data, 'city')}
            errMsg={errMsg.city}
            required
          />
        </div>
        <div className="personal-email-block">
          <div>
            <b>Email: </b>
            {getProfile.userEmail && getProfile.userEmail}
          </div>
          {/* <CheckBox
            label={t('profile.profileCheckBox')}
            onChange={(data) => handleChange(data, 'isEmailVisible')}
            value={PersonalDetails.isEmailVisible}
            size="small"
          /> */}
        </div>
      </PersonalContainer>
      <SubmitContainer className="modal-footer">
        <Button label={t('profile.Submit')} onClick={handleSubmit} type="text" />
        <Button
          label={t('profile.Close')}
          onClick={() => onClose(false, 'personal')}
          type="text"
        />
      </SubmitContainer>
    </>
  );
};
export default PersonalDetails;
